export default [
  {
    path: '/total-score-grading-ranges',
    name: 'total-score-grading-range',
    meta: { requiresAuth: true },
    component: () => import('@/pages/total-score-grading-ranges/index.vue')
  }
]
